import { isRouteActive } from '../lib/utils';

export function hasActiveChild(
  children: Array<{
    path?: string;
    end?: boolean | ((path: string) => boolean);
    children?: Array<{
      path: string;
      end?: boolean | ((path: string) => boolean);
    }>;
  }>,
  currentPath: string,
): boolean {
  return children.some((child) => {
    if ('path' in child && child.path) {
      if (isRouteActive(child.path, currentPath, child.end)) {
        return true;
      }
    }
    if ('children' in child && child.children) {
      return hasActiveChild(child.children, currentPath);
    }
    return false;
  });
}
